/**
 * Creates a function that throws Error created with errorFactory
 *
 * @type {<A extends any[], E extends Error>(errorFactory: (...args: A) => E) => (...args: A) => never}
 */
export const createAndRaise = errorFactory => (...args) => {
	throw errorFactory(...args);
};
